import { TableSettlementMultiCurrency } from "../../../settlement/src/TableSettlementMultiCurrency";
import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementControl extends Layout {
    buttonUpdateYear: Button;
    checkboxAddlTaxOverrideHours: Checkbox;
    checkboxAutoSoPuPay2: Checkbox;
    checkboxAutoSoPuPay: Checkbox;
    checkboxBolReportPrint: Checkbox;
    checkboxBreakAfterCarrSubtotal: Checkbox;
    checkboxBreakAfterOwnopSubtotal: Checkbox;
    checkboxCompanyPuAcct: Checkbox;
    checkboxCompanySoAcct: Checkbox;
    checkboxCreateReady: Checkbox;
    checkboxDeductTiedOrder: Checkbox;
    checkboxDeductWarning: Checkbox;
    checkboxDirDepHoliday: Checkbox;
    checkboxDirDepPrintdebit: Checkbox;
    checkboxDirDepSaturday: Checkbox;
    checkboxDirDepSepfileCo: Checkbox;
    checkboxDirDepSunday: Checkbox;
    checkboxEmailAtPosting: Checkbox;
    checkboxManifestSPPay2: Checkbox;
    checkboxManifestSPPay: Checkbox;
    checkboxOT: Checkbox;
    checkboxOwnerPuAcct: Checkbox;
    checkboxOwnerSoAcct: Checkbox;
    checkboxPayUnbilled: Checkbox;
    checkboxPrintDeduct: Checkbox;
    checkboxPrintExpandedPaySummary: Checkbox;
    checkboxPrintStops: Checkbox;
    checkboxPrintTaxId: Checkbox;
    checkboxPrintWindow: Checkbox;
    checkboxPrintZeroCk: Checkbox;
    checkboxPrintZeroDebit: Checkbox;
    checkboxRequirePayPeriods: Checkbox;
    checkboxSuppressPayRates: Checkbox;
    checkboxSuppressRates: Checkbox;
    checkboxTransByContStat: Checkbox;
    checkboxWcompPrintOption: Checkbox;
    dataheaderControl: DataHeader;
    horizontalspacer13: HorizontalSpacer;
    horizontalspacer14: HorizontalSpacer;
    horizontalspacer15: HorizontalSpacer;
    horizontalspacer16: HorizontalSpacer;
    horizontalspacer17: HorizontalSpacer;
    horizontalspacer18: HorizontalSpacer;
    horizontalspacer19: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer20: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacerCOPU: HorizontalSpacer;
    horizontalspacerCOSO: HorizontalSpacer;
    horizontalspacerOOPU: HorizontalSpacer;
    horizontalspacerOOSO: HorizontalSpacer;
    labelD: Label;
    labelH: Label;
    labelU: Label;
    layoutTableSettlementMultiCurrency: TableSettlementMultiCurrency;
    panelAgent: Panel;
    panelAging1: Panel;
    panelAging2: Panel;
    panelAutoGen2: Panel;
    panelAutoGen: Panel;
    panelCarrier: Panel;
    panelCommissions: Panel;
    panelDD2: Panel;
    panelDD3: Panel;
    panelDD4: Panel;
    panelDefault: Panel;
    panelDefaults2: Panel;
    panelDriver: Panel;
    panelDriverPUnSO: Panel;
    panelGeneral2: Panel;
    panelGeneral: Panel;
    panelMC2: Panel;
    panelMC: Panel;
    panelOO: Panel;
    panelOOPUnSO: Panel;
    panelOffice2: Panel;
    panelOffice: Panel;
    panelPrintPost2: Panel;
    panelPrintPost3: Panel;
    panelPrintPost4: Panel;
    panelPrintPost: Panel;
    panelSettleCreate: Panel;
    panelSettlementCreationFields: Panel;
    panelWires2: Panel;
    panelWires3: Panel;
    panelWires: Panel;
    sourcePayrollControl: DataSource;
    sourcePayrollControlMulticurrency: DataSource;
    switchEnableCommissions: Switch;
    tabAgent: Tab;
    tabAging: Tab;
    tabCarrier: Tab;
    tabCarriers: Tab;
    tabCommissions: Tab;
    tabCompanyDriver: Tab;
    tabDirectDeposit: Tab;
    tabDriver: Tab;
    tabGeneral: Tab;
    tabMulticurrency: Tab;
    tabOO: Tab;
    tabOffice: Tab;
    tabPayee: Tab;
    tabPrintPost: Tab;
    tabSettleCreate: Tab;
    tabWireAdvances: Tab;
    tabWiresOO: Tab;
    tabsetAccount: Tabset;
    tabsetControlGroups: Tabset;
    tabsetWireAdv: Tabset;
    textboxAchBatchClassCode: Textbox;
    textboxAchOptionalSecurityLn: Textbox;
    textboxAddressWhere: Textbox;
    textboxAdjustmentGlid: Textbox;
    textboxAdvanceArGlid: Textbox;
    textboxAgePeriod1: Textbox;
    textboxAgePeriod1Desc: Textbox;
    textboxAgePeriod2: Textbox;
    textboxAgePeriod2Desc: Textbox;
    textboxAgePeriod3: Textbox;
    textboxAgePeriod3Desc: Textbox;
    textboxAgePeriod4: Textbox;
    textboxAgePeriod4Desc: Textbox;
    textboxAgentAdvGlid: Textbox;
    textboxAgentCashGlid: Textbox;
    textboxAgentExpGlid: Textbox;
    textboxAgentPayGlid: Textbox;
    textboxBankNumber: Textbox;
    textboxCarrierAdvGlid: Textbox;
    textboxCarrierCashGlid: Textbox;
    textboxCarrierExpGlid: Textbox;
    textboxCarrierInterfaceCashGlid: Textbox;
    textboxCarrierLimitAmount: Textbox;
    textboxCarrierLimitMethod: Textbox;
    textboxCarrierOrderPctLimit: Textbox;
    textboxCarrierPayGlid: Textbox;
    textboxCarrierTransPerDay: Textbox;
    textboxCarrierValidMoveStatus: Textbox;
    textboxCoDiscrData: Textbox;
    textboxCommissionRecurExp: Textbox;
    textboxCommsnPayGlid: Textbox;
    textboxCompCutoffDate: Textbox;
    textboxCompPayFreq: Textbox;
    textboxCompanyLimitAmount: Textbox;
    textboxCompanyLimitMethod: Textbox;
    textboxCompanyOrderPctLimit: Textbox;
    textboxCompanyPuAmt: Textbox;
    textboxCompanyPuCode: Textbox;
    textboxCompanySoAmt: Textbox;
    textboxCompanySoCode: Textbox;
    textboxCompanyValidMoveStatus: Textbox;
    textboxContractCashGlid: Textbox;
    textboxCountryId: Textbox;
    textboxCpaCode: Textbox;
    textboxCrUnionGlid: Textbox;
    textboxCurrencyRealizedGlid: Textbox;
    textboxCurrencyUnrealizedGlid: Textbox;
    textboxCurrentProcessYear: Textbox;
    textboxDaysToPay: Textbox;
    textboxDirDepClassDesc: Textbox;
    textboxDirDepClassDescCCD: Textbox;
    textboxDirDepCompId: Textbox;
    textboxDirDepDays: Textbox;
    textboxDirDepDestFlag: Textbox;
    textboxDirDepDestName: Textbox;
    textboxDirDepFilename: Textbox;
    textboxDirDepFormat: Textbox;
    textboxDirDepMinAmt: Textbox;
    textboxDirDepOrigName: Textbox;
    textboxDirDepOrigNum: Textbox;
    textboxDriverCashGlid: Textbox;
    textboxDriverExpGlid: Textbox;
    textboxEarningCode: Textbox;
    textboxFedMinWage: Textbox;
    textboxFedReserveNum: Textbox;
    textboxFuelCashGlid: Textbox;
    textboxGlExpenseWhen: Textbox;
    textboxLeaseOpLiabGlid: Textbox;
    textboxLeaseopAdvGlid: Textbox;
    textboxLeaseopCashGlid: Textbox;
    textboxLeaseopExpGlid: Textbox;
    textboxLeaseopLoansGlid: Textbox;
    textboxLeftAdj: Textbox;
    textboxLevel1Limit: Textbox;
    textboxLevel2Limit: Textbox;
    textboxLevel3Limit: Textbox;
    textboxLoanArGlId: Textbox;
    textboxManifestPay: Textbox;
    textboxNotifyOnChgaftAdvance: Textbox;
    textboxOffCutoffDate: Textbox;
    textboxOffPayFreq: Textbox;
    textboxOfficeCashGlid: Textbox;
    textboxOriginatorId: Textbox;
    textboxOwnerPayGlid: Textbox;
    textboxOwnerPuAmt: Textbox;
    textboxOwnerPuCode: Textbox;
    textboxOwnerSoAmt: Textbox;
    textboxOwnerSoCode: Textbox;
    textboxOwneropLimitAmount: Textbox;
    textboxOwneropLimitMethod: Textbox;
    textboxOwneropOrderPctLimit: Textbox;
    textboxOwneropValidMoveStatus: Textbox;
    textboxOwnopCutoffDate: Textbox;
    textboxOwnopPayFreq: Textbox;
    textboxPayAlloc: Textbox;
    textboxPerdiemGlid: Textbox;
    textboxSettlementPayeeSort: Textbox;
    textboxSettlementRoundingGlid: Textbox;
    textboxSettlementSort: Textbox;
    textboxSettlementSubsort: Textbox;
    textboxTonuEarningCode: Textbox;
    textboxTopAdj: Textbox;
    textboxTrailerRentGlid: Textbox;
    textboxUserTransPerDay: Textbox;
    textboxWcompCalculation: Textbox;
    textboxWcompGlid: Textbox;
    textboxWcompOtherCharge: Textbox;
    textboxWireExpGlid: Textbox;
    textboxWireGlid: Textbox;
    textboxWireIncomeGlid: Textbox;
}
